export default function PromoBanner() {
  return (
    <section className="py-20 bg-gradient-to-r from-orange-500 via-orange-600 to-amber-600 relative overflow-hidden">
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-yellow-300 rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-flashlight-line text-white text-lg"></i>
              <span className="text-white text-sm font-semibold">LIMITED TIME OFFER</span>
            </div>

            <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
              Get 3 Months<br />Premium FREE
            </h2>

            <p className="text-xl text-white/90 mb-8 leading-relaxed">
              Join now and unlock unlimited swaps, priority matching, and exclusive community features. No credit card required to start!
            </p>

            <div className="flex flex-wrap gap-4 mb-8">
              <div className="flex items-center gap-2 text-white">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-base font-medium">Unlimited Swaps</span>
              </div>
              <div className="flex items-center gap-2 text-white">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-base font-medium">Priority Support</span>
              </div>
              <div className="flex items-center gap-2 text-white">
                <div className="w-6 h-6 bg-white/20 rounded-full flex items-center justify-center">
                  <i className="ri-check-line text-sm"></i>
                </div>
                <span className="text-base font-medium">Verified Badge</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <button className="bg-white text-orange-600 px-8 py-4 rounded-full text-base font-semibold hover:bg-gray-50 transition-all shadow-2xl hover:shadow-3xl hover:scale-105 whitespace-nowrap cursor-pointer">
                Claim Your Free Trial
                <i className="ri-arrow-right-line ml-2"></i>
              </button>
              <button className="bg-white/10 backdrop-blur-sm text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-white/20 transition-all border-2 border-white/30 whitespace-nowrap cursor-pointer">
                Learn More
              </button>
            </div>

            <p className="text-white/70 text-sm mt-6">
              Offer ends December 31, 2024 • No credit card required
            </p>
          </div>

          <div className="relative">
            <div className="relative bg-white/10 backdrop-blur-md rounded-3xl p-8 border border-white/20 shadow-2xl">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-gray-900 px-6 py-3 rounded-full font-bold text-lg shadow-xl transform rotate-12">
                Save $147
              </div>

              <div className="space-y-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-6 border border-white/20">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center">
                        <i className="ri-vip-crown-line text-white text-2xl"></i>
                      </div>
                      <div>
                        <p className="text-white font-bold text-lg">Premium Plan</p>
                        <p className="text-white/70 text-sm">3 Months Free</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <p className="text-white/70 text-sm line-through">$49/mo</p>
                      <p className="text-white font-bold text-2xl">$0</p>
                    </div>
                  </div>
                  <div className="space-y-3">
                    <div className="flex items-center gap-2 text-white/90 text-sm">
                      <i className="ri-check-double-line text-green-300"></i>
                      <span>Unlimited item listings</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/90 text-sm">
                      <i className="ri-check-double-line text-green-300"></i>
                      <span>Advanced matching algorithm</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/90 text-sm">
                      <i className="ri-check-double-line text-green-300"></i>
                      <span>Featured profile placement</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/90 text-sm">
                      <i className="ri-check-double-line text-green-300"></i>
                      <span>24/7 priority customer support</span>
                    </div>
                  </div>
                </div>

                <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-6 border border-white/10">
                  <div className="flex items-center gap-3 mb-4">
                    <div className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center">
                      <i className="ri-gift-line text-white text-xl"></i>
                    </div>
                    <p className="text-white font-semibold">Bonus Rewards</p>
                  </div>
                  <div className="space-y-2">
                    <div className="flex items-center gap-2 text-white/80 text-sm">
                      <i className="ri-star-line text-yellow-300"></i>
                      <span>$50 swap credit included</span>
                    </div>
                    <div className="flex items-center gap-2 text-white/80 text-sm">
                      <i className="ri-star-line text-yellow-300"></i>
                      <span>Exclusive community events access</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-yellow-400 rounded-full blur-3xl opacity-50"></div>
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-orange-300 rounded-full blur-3xl opacity-50"></div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 mt-16 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-user-add-line text-white text-2xl"></i>
            </div>
            <p className="text-white font-bold text-2xl mb-1">2,847</p>
            <p className="text-white/80 text-sm">New Members Today</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-arrow-left-right-line text-white text-2xl"></i>
            </div>
            <p className="text-white font-bold text-2xl mb-1">15,234</p>
            <p className="text-white/80 text-sm">Active Swaps</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-star-line text-white text-2xl"></i>
            </div>
            <p className="text-white font-bold text-2xl mb-1">4.9/5</p>
            <p className="text-white/80 text-sm">User Rating</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-3">
              <i className="ri-shield-check-line text-white text-2xl"></i>
            </div>
            <p className="text-white font-bold text-2xl mb-1">100%</p>
            <p className="text-white/80 text-sm">Secure Trades</p>
          </div>
        </div>
      </div>
    </section>
  );
}
